<script>
    import { createEventDispatcher, onMount } from 'svelte';
    import Modal from './Modal.svelte';
    import { page } from '$app/stores';
    import Prose from './Prose.svelte';
    import Form from './Form.svelte';
    import Button from './Button.svelte';
    import { img_cdn } from './utils/image';

    let { session, courses } = $page.data;

    export let title = 'Begin the Adventure';
    export let lead = 'Enter your email to get started';
    export let collapsible = false;
    export let show_on_mount = true;
    export let form_name = 'mail-begar';
    export let course_slug = '';
    export let cta_text = 'Submit'

    const dispatch = createEventDispatcher();

    let visible = false;

    let course;
    if (course_slug && courses) {
        course = courses.find((c) => c.slug === course_slug);
    }

    onMount(() => {
        if (show_on_mount) {
            handle_open();
        }
    });

    const handle_submit = (event) => {
        visible = false;
        localStorage.setItem('has_email', '1');
        localStorage.setItem('ctm_email', event.detail.email);
        dispatch('success');
    };

    const handle_close = () => {
        visible = false;
    };

    const handle_open = () => {
        const begged_successfully =
            localStorage.getItem('has_email') === '1' || localStorage.getItem('ctm_email');

        if (!begged_successfully && !session) {
            visible = true;
        } else {
            dispatch('success');
        }
    };

    export const show = () => handle_open();
</script>

{#if visible}
    <Modal collapsible={collapsible} xs on:close={handle_close}>
        <img
            src={img_cdn('/c/media-literacy.png')}
            class="icon spin3d w-48 h-48 object-cover mx-auto mb-2 mt-8"
            alt=""
        />
        <Prose xs invert class="text-center mt-8 prose-headings:mb-0">
            <h1>{@html title}</h1>
            <p>{@html lead}</p>
            <Form on:submit={handle_submit}
                label_text=''
                cta_text={cta_text}
                narrow
                form_name={form_name}
                data={{
                    course_slug,
                    course_id: course?.id,
                    course_title: course?.title,
                }}
            />
        </Prose>
        {#if collapsible}
            <Button sm
                class="mt-4 mx-auto block w-fit" 
                on:click={handle_close}
                >Close</Button
            >
        {/if}
    </Modal>
{/if}

<style scoped>
    .icon {
        animation: spin3d 1s cubic-bezier(0.215, 0.61, 0.355, 1) forwards;
        animation-iteration-count: 1;

        animation-delay: 300ms;
        transform-origin: center;
        transform-box: fill-box;
        /* backface-visibility: hidden; */
        border-radius: 50%;
        transform-style: preserve-3d;
        perspective: 1000px;
        /* background-color: red; */
    }

    @keyframes spin3d {
        from {
            transform: rotateY(0deg) scale(1);
        }
        to {
            transform: rotateY(1080deg) scale(1);
        }
    }
</style>